/**
 * Notification API
 *
 * API functions for notification operations.
 */

import api from './axios';

/**
 * Get notifications
 */
export const getNotifications = async (params = {}) => {
  const response = await api.get('/notifications', { params });
  return response.data;
};

/**
 * Get unread count
 */
export const getUnreadCount = async () => {
  const response = await api.get('/notifications/unread-count');
  return response.data;
};

/**
 * Mark notification as read
 */
export const markAsRead = async (id) => {
  const response = await api.put(`/notifications/${id}/read`);
  return response.data;
};

/**
 * Mark notification as unread
 */
export const markAsUnread = async (id) => {
  const response = await api.put(`/notifications/${id}/unread`);
  return response.data;
};

/**
 * Mark all as read
 */
export const markAllAsRead = async () => {
  const response = await api.put('/notifications/read-all');
  return response.data;
};

/**
 * Delete notification
 */
export const deleteNotification = async (id) => {
  const response = await api.delete(`/notifications/${id}`);
  return response.data;
};

/**
 * Clear all notifications
 */
export const clearAll = async () => {
  const response = await api.delete('/notifications/all');
  return response.data;
};

export default {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAsUnread,
  markAllAsRead,
  deleteNotification,
  clearAll,
};
